import React from "react";
import { Helmet } from "react-helmet";

import ProductsSection from "../Components/Products/ProductsSection";
import StaticBanner from "../Components/Products/StaticBanner";
import VangalProductsSection from "../Components/Products/VangalProductsSection";
import ContactSection from "../Components/ContactSection";

export default function Products() {
  return (
    <>
      <Helmet>
        <title>Our Products | Vangal Dairies</title>
        <meta
          name="description"
          content="Explore the full range of dairy products from Vangal Dairies including milk, curd, ghee, paneer, butter, and more. Fresh, hygienic, and traditionally crafted dairy products."
        />
      </Helmet>

      <StaticBanner />
      <VangalProductsSection />
      <ProductsSection />
      <ContactSection />
    </>
  );
}
